import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import axiosAuth from "../../../axiosAuth";

export interface CrmResourceManagementData {
  id: string;
  schoolId: string;
  crmOpsStatus: "Green" | "Yellow" | "Red";
  comment: string;
  regionHeadId: string | null;
  relationshipManagerId: string | null;
  schoolEducatorName: string | null;
  schoolEducatorMobileNumber: string | null;
  schoolEducatorEmailId: string | null;
  createdBy: string;
  lastUpdatedBy: string;
  createdAt: string;
  updatedAt: string;
  __v?: number;

  // ✅ Add these missing fields:
  regionHeadData: {
    _id: string;
    profile_id: string;
    name: string;
    email: string;
    role: string[];
  }[];

  relationshipManagerData: {
    _id: string;
    profile_id: string;
    name: string;
    email: string;
    role: string[];
  }[];

  createdByData: {
    _id: string;
    profile_id: string;
    name: string;
    email: string;
    role: string[];
  }[];

  crmComments: {
    _id: string;
    CrmHeadCommentId: string;
    comment: string;
    createdBy: string;
    createdAt: string;
    commentBy: string;
  }[];
}


export interface CrmResourceManagementResponse {
  data: CrmResourceManagementData;
}

const fetchCrmResourceManagement = async (schoolId: string) => {
  const response = await axiosAuth.get<CrmResourceManagementResponse>(
    `/v1/school/crm/resource-management/${schoolId}/`
  );
  return response.data;
};

export const useGetCrmResourceManagementQuery = (
  schoolId: string,
  queryParams?: Omit<
    UseQueryOptions<
      CrmResourceManagementResponse,
      Error,
      CrmResourceManagementResponse,
      ["crm-resource-management", string]
    >,
    "queryKey" | "queryFn"
  >
) =>
  useQuery<CrmResourceManagementResponse, Error, CrmResourceManagementResponse, ["crm-resource-management", string]>({
    queryKey: ["crm-resource-management", schoolId],
    queryFn: () => fetchCrmResourceManagement(schoolId),
    enabled: !!schoolId,
    ...(queryParams || {}),
  });
